<template>
  <div class="videoBox">
    <div v-if="type == 1" class="themeBox flex" :style="'justify-content: '+justify">
      <div class="themeList hand"
        :style="marginIndex.indexOf(index) >= 0?'margin-right: 0px;margin-bottom: '+marginBottom/100+'rem;width:'+itemWidth/100+'rem':'margin-right: '+marginRight/100+'rem;margin-bottom: '+marginBottom/100+'rem;width:'+itemWidth/100+'rem'"
        @click="handDetail(item)"
        v-for="(item,index) in videoList" :key="index"
        @mouseover="hoverVideo(index)"
        @mouseleave="closeVideo(index)"
      >
        <div class="image" :style="videoIndex == index?'text-align:center;background:#515151;position:relative':'text-align:center;position:relative'">
          <!-- <video
            ref="listVideos"
            v-show="videoIndex == index && item.isPlay"
            style="width:100%;height:100%;object-fit: fill"
            :src="item.tApiVideoChildList[0].videoUrl"
            controlslist="nodownload"
            @timeupdate="checkTime(index)"
            type="video/mp4"
          >
            您的浏览器不支持 video 标签。
          </video> -->
           <!-- v-show="videoIndex != index && !item.isPlay" -->
            <!-- v-show="videoIndex != index && !item.isPlay" -->
          <el-image :src="item.bigPreview" :fit="'contain'" class="image" style="height: 1.3rem;width: 100%;"/>
          <img src="../assets/images/videostart.png" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);width:.5rem;height: .5rem;">
        </div>
        <div class="blackActive" v-if="videoIndex == index" style="background:#515151;height: 1.14rem;">
          <div class="blackBox flex" style="background:#515151;">
            <div class="themeTit w100 twoHidden" style="height: .4rem;">{{item.videoTitle}}</div>
            <div class="themeTea w100 twoHidden">简介：<span v-html="item.synopsis"></span></div>
          </div>
        </div>
        <div class="listDi" v-else>
          <div class="themeTit w100 twoHidden" style="height: .4rem;">{{item.videoTitle}}</div>
          <div class="flex w100" style="justify-content: space-between;">
            <div class="themeTea oneHidden" style="width:75%;">讲师：{{item.authorNameList}}</div>
            <div v-if="item.watchCount && Number(item.watchCount) > 0" class="themeNum flex" style="height:.2rem;align-items: center;">
              <span style="font-size: .16rem;padding-right:.04rem;" class="el-icon-view"></span>
              <span>{{ item.watchCount }}</span>
            </div>
            <div v-else class="themeNum flex" style="height:.2rem;align-items: center;">
              <span style="font-size: .16rem;padding-right:.04rem;" class="el-icon-view"></span>
              <span>0</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="type == 2" class="themeBox flex" :style="'justify-content: '+justify">
      <div class="themeList hand"
        :style="marginIndex.indexOf(index) >= 0?'margin-right: 0px;margin-bottom: '+marginBottom/100+'rem;width:'+itemWidth/100+'rem':'margin-right: '+marginRight/100+'rem;margin-bottom: '+marginBottom/100+'rem;width:'+itemWidth/100+'rem'"
        @click="handDetail(item)"
        v-for="(item,index) in videoList" :key="index"
      >
        <div class="image" style="text-align:center;height: 1.3rem;">
          <video
            :poster="item.bigPreview"
            ref="listVideos"
            style="width:100%;height:100%;object-fit: contain"
            :src="item.videoUrl"
            controlslist="nodownload"
            @timeupdate="checkTime(index)"
            type="video/mp4"
          >
            您的浏览器不支持 video 标签。
          </video>
          <!-- <el-image v-show="videoIndex != index && !item.isPlay" :src="item.bigPreview" :fit="'contain'" class="image" style="height: 130px;width: 100%;"/> -->
        </div>
        <div class="blackActive" v-if="videoIndex == index" style="background:#515151;">
          <div class="blackBox flex" style="background:#515151;">
            <div class="themeTit twoHidden" style="height: .4rem;">{{item.videoTitle}}</div>
            <div class="themeTea twoHidden">简介：<span v-html="item.synopsis"></span></div>
          </div>
        </div>
        <div class="listDi" v-else>
          <div class="themeTit w100 twoHidden" style="height: .4rem;">{{item.videoTitle}}-{{item.videoChildTitle}}</div>
          <div class="flex w100" style="justify-content: space-between;">
            <div class="themeTea oneHidden" style="width:75%;">讲师：{{item.authorNameList}}</div>
            <div v-if="item.watchCount && Number(item.watchCount) > 0" class="themeNum flex" style="height:.2rem;align-items: center;">
              <span style="font-size: .16rem;padding-right:.04rem;" class="el-icon-view"></span>
              <span>{{ item.watchCount }}</span>
            </div>
            <div v-else class="themeNum flex" style="height:.2rem;align-items: center;">
              <span style="font-size: .16rem;padding-right:.04rem;" class="el-icon-view"></span>
              <span>0</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videoList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    itemWidth:{
      type: Number,
      default: 240
    },
    listTotal: {
      type: Number,
      default: 0
    },
    htmlName: {
      type: String,
      default: ''
    },
    justify: {
      type: String,
      default: 'start'
    },
    marginRight: {
      type: Number,
      default: 20
    },
    marginBottom: {
      type: Number,
      default: 34
    },
    marginIndex: {
      type: Array,
      default: ()=> {
        return [6, 13]
      }
    },
    type:  {
      type: Number,
      default: 1    // 2 列表为视频子集列表
    }
  },
  data() {
    return {
      videoIndex: '-1',
    };
  },
  methods: {
    hoverVideo(index) {
      this.videoIndex = index;
      // this.$refs.listVideos[index].play();
      this.$refs.listVideos[index].currentTime = 0;
      this.videoList[index].isPlay = true;
    },
    checkTime(index) {
      var zongTime = this.$refs.listVideos[index].duration;
      var boTime;
      if(zongTime > 10) {
        boTime = 10;
      } else {
        boTime = zongTime/2;
      }
      const videos = this.$refs.listVideos[index];
      if(videos.currentTime > boTime) {
        this.$refs.listVideos[index].currentTime = 0;;
        this.$refs.listVideos[index].play();
      }
    },
    closeVideo(index) {
      this.videoIndex = '-1';
      this.videoList[index].isPlay = false;
      // this.$refs.listVideos[index].pause();
    },
    handDetail(item) {
      this.$emit('toDetail', item);
    },
  }
};
</script>

<style>
  .themeBox {
    flex-wrap: wrap;
  }
  .themeBox .themeList {
    width: 2.4rem;
    background: #fff;
    box-shadow: rgb(255 255 255 / 0%) 0px 0px .01rem;
    filter: drop-shadow(rgba(0, 0, 0, 0.15) 0px .03rem .06rem);
    /* border-radius: 10px; */
  }
  .themeBox .image {
    /* border-top-left-radius: 10px; */
    /* border-top-right-radius: 10px; */
  }
  .themeBox .listDi {
    display: flex;
    flex-wrap: wrap;
    height: 1.14rem;
    padding: .14rem;
    padding-bottom: 0px;
    box-sizing: border-box;
  }
  .themeBox .listDi .themeTit {
    font-weight: bold;
  }
  .themeBox .listDi .themeTea {
    font-size: .14rem;
    color: #312f2f;
  }
  .themeBox .listDi .themeNum span {
    font-size: .12rem;
    color: #838383;
  }
  .themeBox .blackActive {
    width: 100%;
    background: #515151;
    /* border-bottom-left-radius: 10px; */
    /* border-bottom-right-radius: 10px; */
    position: relative;
    height: 1.24rem;
  }
  .themeBox .blackActive .blackBox {
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    top: 0px;
    left: 0px;
    height: 100%;
    background: #515151;
    z-index: 2000;
    padding: 0px .14rem;
    align-content: center;
    flex-wrap: wrap;
    /* border-bottom-left-radius: 10px; */
    /* border-bottom-right-radius: 10px; */
  }
  .themeBox .blackActive .themeTit {
    font-weight: bold;
    color: #fff;
  }
  .themeBox .blackActive .themeTea {
    font-size: .14rem;
    color: #fff;
    margin-top: .08rem;
  }
  .themeBox .blackActive .themeBo {
    font-size: .14rem;
    color: #fff;
    height: .4rem;
    line-height: .4rem;
    padding: 0px .1rem;
    background: #2981E2;
  }
</style>



// WEBPACK FOOTER //
// src/components/videoItem.vue